import {
  validName
} from '@/services/index'
import i18n from '@/lib/language'
const testPwd = (value) => {
  // const result1 = /^[\w\W]{8,30}$/.test(value)
  // const result2 = /[0-9]/.test(value)
  // const result3 = /[a-zA-Z]/.test(value)
  // if (result1 && result2 && result3) {
  //   return true
  // }
  // return false
  if (value.length >= 8) {
    return true
  }
  return false
}
const rules = {
  orgname: [
    { required: true, message: i18n.t('message["841"]'), trigger: 'blur' }
  ],
  projectname: [
    { required: true, message: i18n.t('message["814"]'), trigger: 'blur' }
    // {
    //   validator (rule, value, callback) {
    //     if (value && (value.replace(/[\u4E00-\u9FA5]/g, 'aa').length > 16)) {
    //       callback(new Error('项目名称最多8位汉字或者16位数字和字母'))
    //     } else {
    //       callback()
    //     }
    //   },
    //   trigger: 'blur'
    // }
  ],
  transferuserid: [
    { required: true, message: i18n.t('message["785"]') }
  ],
  adminlist: [
    { required: true, message: i18n.t('message["861"]') }
  ],
  pid: [
    { required: true, message: '请选择关联项目' }
  ],
  password: [
    { required: true, message: i18n.t('message["784"]'), trigger: 'blur' },
    {
      validator (rule, value, callback) {
        if (value && !testPwd(value)) {
          callback(new Error(i18n.t('message["753"]')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  repeatPwd: [
    { required: true, message: i18n.t('message["890"]'), trigger: 'blur' },
    {
      validator (rule, value, callback) {
        if (!testPwd(value)) {
          callback(new Error(i18n.t('message["753"]')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  email: [
    { required: true, type: 'email', message: i18n.t('message["834"]'), trigger: 'blur' }
  ],
  validCode: [
    { required: true, message: i18n.t('message["824"]'), trigger: 'blur' }
  ],
  username: [
    { required: true, message: i18n.t('message["763"]'), trigger: 'blur' },
    {
      async validator (rule, value, callback) {
        if (value) {
          await validName()
            .params({ username: value })
            .onSuccess((raw) => {
            })
            .onNetSuccess((raw) => {
              const res = raw.data
              if (res.error) {
                callback(new Error(res.message || res.payload[0].message))
              } else {
                callback()
              }
            })
            .config({ tip: false })
            .fetch()
        }
      },
      trigger: 'blur'
    }
  ],
  name: [
    { required: true, message: i18n.t('message["772"]'), trigger: 'blur' }
  ],
  tel: [
    { required: true, message: i18n.t('message["800"]'), trigger: 'blur' },
    {
      validator (rule, value, callback) {
        var errors = []
        if (value && (!/^1\d{10}$/.test(value))) {
          errors.push(
            new Error(
              i18n.t('message["1111"]')
            ))
        }
        return errors
        // if (value && (!/^1\d{10}$/.test(value))){
        //   callback('Two passwords that you enter is inconsistent!');
        // } else {
        //   callback();
        // }
      },
      trigger: 'change'
    }
  ],
  title: [
    { required: true, message: i18n.t('message["67"]'), trigger: 'blur' }
  ],
  identifynumber: [
    { required: true, message: i18n.t('message["786"]'), trigger: 'blur' }
  ]
}
export default rules
